import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Identifiable } from '@mews/std';
import { WithScope } from '@mews-commander/types';
import { ColumnAlignment } from '@mews/b2b-ui';
import EntityTable from '../../entityManagement/components/EntityTable';
import { EntityDeleteButton } from '../../entityManagement/components/EntityDeleteButton';
import { createPagedEntityTableConnect } from '../../entityManagement';
import { getContractFilesForTable } from '../selectors';
import { FileDownloadLink } from '../../../components';
import ContractEditLink from './ContractEditLink';

interface NameParams extends Identifiable {
    name: string;
}

interface NegotiatedRatesParams extends Identifiable {
    negotiatedRates: string;
}

const mapping = [
    {
        valueKey: 'negotiatedRates',
        title: <LocalizedText textKey={TextKey.NegotiatedRates} />,
        render: ({ id, negotiatedRates }: NegotiatedRatesParams, { scope }: WithScope) => (
            <ContractEditLink scope={scope} id={id} name={negotiatedRates} />
        ),
        columnWidth: '40%',
    },
    {
        valueKey: 'contractStartDate',
        title: <LocalizedText textKey={TextKey.Start} />,
    },
    {
        valueKey: 'contractEndDate',
        title: <LocalizedText textKey={TextKey.End} />,
    },
    {
        valueKey: 'name',
        title: <LocalizedText textKey={TextKey.Name} />,
        render: ({ name, id }: NameParams) => <FileDownloadLink name={name} id={id} isCompanyFile />,
    },
    {
        valueKey: 'actions',
        title: <LocalizedText textKey={TextKey.ActionPlural} />,
        render: ({ id }: Identifiable, { scope }: WithScope) => <EntityDeleteButton id={id} scope={scope} />,
        columnWidth: '10%',
        columnAlignment: ColumnAlignment.Right,
    },
];

const FilesTable = EntityTable({ mapping, AdditionalActionComponent: null });

// @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
export default createPagedEntityTableConnect(getContractFilesForTable)(FilesTable);
